// ModalLimitReached.tsx

import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

interface ModalLimitReachedProps {
  show: boolean;
  onHide: () => void;
}

const ModalLimitReached: React.FC<ModalLimitReachedProps> = ({
  show,
  onHide,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage
            id="limit-reached-title"
            defaultMessage="Limit Reached"
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <FormattedMessage
            id="limit-reached-message"
            defaultMessage="You have reached the limit for this action."
          />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          <FormattedMessage id="close" defaultMessage="Close" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalLimitReached;
